import request from '@/utils/request';

export default {
  login(data) {
    return request({ url: '/user/login', method: 'post', data });
  },
  logout() {
    return request({ url: '/user/logout', method: 'post' });
  },
  updatePassword(data) {
    return request({ url: '/user/updatePassword', method: 'post', data });
  },
  
};
